export const ORDER_ADD = "ORDER_ADD";
export const ORDER_SUCCESS = "ORDER_SUCCESS";
export const ORDER_ERROR = "ORDER_ERROR";
export const ORDER_PARAMETERS = "ORDER_PARAMETERS";
export const ORDER_RESTAPI = "ORDER_RESTAPI";



// WEBPACK FOOTER //
// ./src/store/actions/order.js